<template>
  <div class="container small-f">
    <div class="row mt-5">
        <div class="col-12">
            <div class="card shadow-sm p-3 mb-5 bg-body rounded header-hidden">
            <div class="card-body header-edit">
                <!-- <table class="table table-striped">
                    <tr>
                        <td>Product</td>
                        <td>Price</td>
                        <td>Quantity</td>
                        <td>Sub Total</td>
                    </tr>
                </table> -->
                <h4>Product</h4>
                <h4>Price</h4>
                <h4>Quantity</h4>
                <h4>Sub Total</h4>
            </div>
        </div>
        </div>
        <div class="col-12" v-for="(item,index) in cartItemsData" :key="index">
            <div class="card shadow-sm p-3 mb-5 bg-body rounded">
                <div class="card-body header-edit">
                    <div>
                        <img :src="item.thumbnail" class="image-responsive rounded" alt="Product">
                        <span class="img-title">{{item.title}}</span>
                    </div>
                    <div class="text-muted price">
                        ${{(item.price).toLocaleString()}}  
                    </div>
                    <div>
                        <button class="btn btn-light" @click="removeQty(index)">-</button>
                        <span class="mx-3">{{$store.getters.getCartItems[index].qty}}</span>
                        <button class="btn btn-light" @click="addQty(index)">+</button>
                    </div>
                    <div class="price">
                        ${{(Number(item.price)*$store.getters.getCartItems[index].qty).toLocaleString()}}
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4 ms-auto">
            <div class="card ">
            <div class="card-body">
                <h4 class="card-title">Cart Total</h4>
                <div class=" d-flex justify-content-between border-bottom mt-5">
                    <p>SubTotal :</p>
                    <div class="text-muted fw-bold fs-4">${{subTotal}}</div>
                </div>
                <div class=" d-flex justify-content-between border-bottom mt-5">
                    <p>Shipping :</p>
                    <div class="text-muted fw-bold fs-4">Free</div>
                </div>
                <div class=" d-flex justify-content-between mt-5">
                    <p>Total </p>
                    <div class="text-muted fw-bold fs-4">${{subTotal}}</div>
                </div>
                <div class="text-center">
                    <router-link to="/order"><button class="btn btn-danger btn-lg btn-white" @click="order()">Place Order</button></router-link>
                </div>
            </div>
        </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    name : "CartVue",
    data(){
        return{
            cartItemsData : this.$store.getters.getCartItems,
            edit_index : "",
        }
    },
    mounted(){
        console.log(this.cartItemsData);
    },
    methods:{
        removeQty(index){
            this.$store.commit("removeQty",index)
            this.edit_index = index;
        },
        addQty(index){
            this.$store.commit("addQty",index)
        },
        order(){
            this.$store.commit("removeCart",this.edit_index)
        }
    },
    computed : {
        subTotal(){
            let total =  this.$store.getters.getCartItems.map(v=> (v.price*v.qty))
            return total.reduce((total,setTotal)=> total += setTotal,0)
        }
    }
}
</script>

<style>
/* .card {
    border: none !important;
} */

.header-edit{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.header-edit h4{
    color: #6c757d;
}
.image-responsive{
    width: 100px !important;
    height: 100px !important;
}
.img-title{
    display: block;
    margin-top: 3px;
}
.price{
    font-size: 24px;
}
.btn-white{
    color: #fff !important;
}
@media (max-width: 767px) {
    .small-f{
        font-size: 14px;
    }
    .header-hidden{
        display: none !important;
    }
    .header-edit{
    display: flex;
    flex-direction: column;
    align-items: center;
}
}
</style>